import React from "react";
import useWindowSize from "../../../hooks/useWindowSize";
import { webView } from "../../../variables/webView";
import ContentStepHeader from "./ContentStepHeader";
import useIsNoIframe from "../../../hooks/useIsNoIframe";

export default function MobileContentStepHeader() {
  const { isDesktop } = useWindowSize();
  const { isNoIframe } = useIsNoIframe();

  if ((isDesktop && !webView) || !isNoIframe) {
    return null;
  }

  return <ContentStepHeader />;
}
